module.exports = __webpack_public_path__ + "static/media/icon_entered.4fc7735d.svg";